import { services } from '@/mocks/homeData';
import { Link } from 'react-router-dom';

export default function ServicesSection() {
  return (
    <section id="servicos" className="py-12 md:py-16 px-4 md:px-8 bg-background-50">
      <div>
        <h2 className="text-center text-lg md:text-xl font-bold text-secondary-900 tracking-wide mb-10 md:mb-12">
          NOSSOS SERVIÇOS
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {services.map((service) => (
            <article
              key={service.id}
              className="bg-background-100 rounded-lg border border-background-200/70 p-6 md:p-8 text-center hover:shadow-md transition-shadow group"
            >
              {/* Icon */}
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                <span className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center">
                  <i className={`${service.icon} text-xl md:text-2xl`}></i>
                </span>
              </div>

              {/* Title */}
              <h3 className="text-sm font-bold text-secondary-900 mb-2 tracking-wide">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-xs text-foreground-600 leading-relaxed mb-4">
                {service.description}
              </p>

              {/* Link */}
              <Link
                to={service.link}
                className="inline-flex items-center gap-1 text-xs font-semibold text-primary-500 hover:text-primary-600 transition-colors"
              >
                SAIBA MAIS
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
